import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseMenuService, MenuItem } from '@fry/lib/menu';
import { AuthService } from '@fry/lib/auth';
import { SecurityService } from '@fry/lib/security';


@Injectable()
export class UsersFieldsMenu extends BaseMenuService {

    constructor(auth: AuthService, security: SecurityService) {
        super(auth, security);
    }

    cook(): Observable<MenuItem[]> {
        return this.menuWithPermission([{
            id: 'user-fields',
            link: '/user-fields',
            title: $localize `User fields`,
            parent: 'user-management'
        }], 'userFields.view');
    }
}
